import { DevicesRequestPayload, RSU } from '_lib/api';
import { createEntityAdapter, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DeviceReducerState, RsuDowntimesRequestPayload } from './devicesTypes';

const initialState: DeviceReducerState = {
  loading: false,
  rsuDowntimes: {
    data: null,
    loading: false,
    error: null,
  },
};

export const devicesAdapter = createEntityAdapter({
  selectId: (el: RSU) => el.id,
});

const devicesReducer = createSlice({
  name: 'devices',
  initialState: devicesAdapter.getInitialState(initialState),
  reducers: {
    devicesRequest: (state, _action: PayloadAction<DevicesRequestPayload>) => {
      state.loading = true;
    },
    devicesResponse: (state, action: PayloadAction<RSU[]>) => {
      if (state.loading) {
        devicesAdapter.setAll(state, action.payload);
        state.loading = false;
      }
    },
    deviceRequest: (state, _action: PayloadAction<string>) => {
      state.loading = true;
    },
    deviceResponse: (state, action: PayloadAction<RSU>) => {
      const updatedRSU = action.payload;
      devicesAdapter.updateOne(state, { id: updatedRSU.id, changes: updatedRSU });
      state.loading = false;
    },
    rsuDowntimesRequest: (state, _action: PayloadAction<RsuDowntimesRequestPayload>) => {
      state.rsuDowntimes.loading = true;
      state.rsuDowntimes.error = null;
    },
    rsuDowntimesResponse: (state, action: PayloadAction<any>) => {
      state.rsuDowntimes.data = action.payload;
      state.rsuDowntimes.loading = false;
      state.rsuDowntimes.error = null;
    },
    rsuDowntimesError: (state, action: PayloadAction<string>) => {
      state.rsuDowntimes.loading = false;
      state.rsuDowntimes.error = action.payload;
    },
    rsuDowntimesCsvRequest: (state, _action: PayloadAction<RsuDowntimesRequestPayload>) => {
      // No need to set loading state for CSV, it's a direct download
    },
    devicesAddOne: devicesAdapter.addOne,
    devicesAddMany: devicesAdapter.addMany,
    devicesUpdate: devicesAdapter.updateOne,
    devicesRemove: devicesAdapter.removeOne,
    devicesUpsertOne: devicesAdapter.upsertOne,
  },
});

export default devicesReducer;
